import React, { useEffect, useRef } from 'react';
import Header from './head';
import SideMenu from './sidemenu';
import { Outlet } from 'react-router-dom';
import './Menu.css';


const Menu = ({logout , refreshAccessToken, fetchSystemInfo}) => {

    const isInitialRender = useRef(true);

    useEffect(() => {
        let accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');

        if (accessToken && refreshToken) {
            // Call fetchSystemInfo on the first render
            if (isInitialRender.current) {
                fetchSystemInfo();
                isInitialRender.current = false;
            };   
        };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Header logout={logout}/>
            <SideMenu />
            <div id="Main">
                <Outlet /> {}
            </div>
        </div>
    );
};


export default Menu;
